module.exports = __webpack_public_path__ + "img/rustore.82e39c2d.svg";